import * as React from 'react'

import { CheckboxField, Link, Section } from 'app2/components';

import { marketingUrl } from '../marketingUrl';

export function TOSField() {
  return <Section name='terms' label={<>I agree to the&nbsp;<Link to={marketingUrl('/tou')} target="_blank">terms and conditions</Link></>} required boolean component={CheckboxField} />
}
